import { render, staticRenderFns } from "./_dashboardad.vue?vue&type=template&id=e44dea22&lang=pug"
import script from "./_dashboardad.vue?vue&type=script&lang=js"
export * from "./_dashboardad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports